var e;!function(e){e.FullTextTestId="CorvaUI.TextMiddleTruncated.FullTextTestId",e.TruncatedTextTestId="CorvaUI.TextMiddleTruncated.TruncatedTextTestId"}(e||(e={}));export{e as TextMiddleTruncatedTestIds};
